module.exports = __webpack_public_path__ + "static/media/06.soothraparva photo_s 011.925a6240.jpg";